<cb-dialog [dialogHeading]="(mappedItem.id > 0 ? 'Edit' : 'Create') + ' Line'">
    <form #editLineItemForm="ngForm">
        <div class="cb-margin flex-row">
            @if (!mappedItem.isNoteLine) {
                <div class="flex-col flex">
                    <cb-display-value-new
                        class="flex-row"
                        [value]="categoryPathString"
                        label="Product Category"
                    >
                    </cb-display-value-new>
                    <div class="flex-row">
                        <div class="flex">
                            <cb-product-centre-autocomplete-scroller
                                class="cb-margin-right flex"
                                label="Product"
                                name="product"
                                [(ngModel)]="selectedProduct"
                                [required]="true"
                                [businessEntityIds]="businessEntityIdAndNationalId"
                                [hideCompositeItems]="true"
                                [orderByStandardProduct]="true"
                                (searchTextChanged)="updateLineItemDescription($event)"
                                (optionSelected)="productUpdate($event)"
                                [maxlength]="1499"
                                [ignoreTierBasedSorting]="true"
                            >
                            </cb-product-centre-autocomplete-scroller>
                        </div>
                        <cb-product-centre-find
                            name="selectedProduct"
                            class="product-centre-find"
                            [initializeSearchOnLoad]="true"
                            [businessEntityIdsToSortBy]="businessEntityIdAndNationalId"
                            [restrictedBusinessEntityIds]="businessEntityIdAndNationalId"
                            [hideNationalRate]="true"
                            [showCurrentProduct]="true"
                            [currentProductTitle]="'Current Manual Purchase Order Line Item'"
                            [existingSlotItem]="existingSlotItem"
                            (productSelected)="productUpdate($event, true)"
                            [required]="true"
                            [buttonOnly]="true"
                            [maxlength]="1499"
                            [activeOnly]="true"
                            [ignoreTierBasedSorting]="true"
                        >
                        </cb-product-centre-find>
                    </div>
                    <div style="margin-top: -20px">
                        <span class="mat-caption">{{
                            mappedItem.offeringId > 0 ? 'Product Selected' : 'Free Text'
                        }}</span>
                    </div>
                    <cb-input
                        label="Code"
                        name="code"
                        [(ngModel)]="mappedItem.productCode"
                        [disabled]="mappedItem?.offeringId != null || loadingRate"
                        [required]="true"
                    ></cb-input>
                    <cb-select
                        label="UOM"
                        name="uom"
                        [(ngModel)]="mappedItem.uomId"
                        (change)="uomChanged()"
                        [disabled]="mappedItem?.offeringId != null || loadingRate"
                        [options]="uomList"
                    ></cb-select>
                    <cb-input
                        type="number"
                        label="Quantity"
                        [required]="true"
                        [(ngModel)]="mappedItem.quantity"
                        name="quantity"
                        [suffix]="mappedItem.uom"
                        allow-cents="false"
                    ></cb-input>
                    <cb-currency
                        label="Rate"
                        name="rate"
                        [(ngModel)]="mappedItem.rate"
                        [required]="true"
                        [disabled]="mappedItem.costToBeDetermined || loadingRate"
                        [inclGst]="false"
                    ></cb-currency>
                    <cb-checkbox
                        label="Unknown Rate"
                        name="costToBeDetermined"
                        [(ngModel)]="mappedItem.costToBeDetermined"
                        (change)="unknownRateChanged()"
                    ></cb-checkbox>
                    <cb-text-area
                        label="Internal Notes"
                        name="internalNotes"
                        [maxlength]="1024"
                        [(ngModel)]="mappedItem.internalNotes"
                    ></cb-text-area>
                    <cb-checkbox
                        label="GST Applies"
                        name="gstApplies"
                        [(ngModel)]="mappedItem.gstApplies"
                    ></cb-checkbox>
                </div>
            }
            @if (mappedItem.isNoteLine) {
                <div class="flex-col flex">
                    <cb-text-area
                        label="Note"
                        name="description"
                        [(ngModel)]="mappedItem.description"
                        [maxlength]="1024"
                        [required]="true"
                    ></cb-text-area>
                </div>
            }
        </div>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="editLineItemForm.pristine || editLineItemForm.invalid || loadingRate"
            (cbClick)="saveDialog()"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancelDialog()">Cancel</button>
    </div>
</cb-dialog>
